export function isLocalhostSync(): boolean {
  // During SSR, assume it's development environment for safety
  if (typeof window === "undefined") return true;

  const hostname = window.location.hostname;

  // Check for various localhost patterns
  return (
    hostname === "localhost" ||
    hostname === "127.0.0.1" ||
    hostname.startsWith("192.168.") || // Local network IPs
    hostname.startsWith("10.") || // Local network IPs
    hostname === "::1" || // IPv6 localhost
    hostname.includes(".local") || // .local domains
    hostname === "0.0.0.0"
  );
}
